/**
 * Controllers
 * @module controllers
 */
define(function (require, exports) {

    'use strict';

    /**
     * Main controller
     * @ngInject
     * @constructor
     */

    function MainCtrl(model, $rootScope, lpWidget, lpCoreUtils, lpCoreBus, lpCoreI18nUtils, lpCoreI18n, lpCoreError, $http, $timeout, $compile) {

        var self = this;

        self.state = model.getState();
        self.utils = lpCoreUtils;
        self.widget = lpWidget;
        self.isMobileNative = lpWidget.getPreference('native') || false;
        self.locales = lpWidget.getPreference('locales') || 'en-US';
        self.localesWithCode = [];

        function getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length >= 2) return parts.pop().split(";").shift();
        }

        var arabicLabel = "العربية";
        self.selectedLocale = getCookie('userLanguage') || 'en-US';
        if (self.locales && self.locales.length > 0) {
            self.locales = self.locales.split(',');
            angular.forEach(self.locales, function (value, index) {
                value = value.trim();
                var langCode = value.split('-')[0];
                var localeLabel = "";
                if (langCode && langCode === 'ar') {
                    localeLabel = arabicLabel;
                } else {
                    localeLabel = langCode.toUpperCase();
                }
                //do not set arabic temporarily
                if (langCode && langCode !== 'ar') {
                    self.localesWithCode.push({ 'lang_code': localeLabel, 'locale_code': value });
                }
            });
        }

        self.isSelectedLocale = function (localeCode) {
            return localeCode === self.selectedLocale;
        };

        self.changeLocale = function (locale, event) {
            if (event) {
                event.preventDefault();
            }
            let localeArr = locale.split('-');
            let params = {
                'languageCode': localeArr[0],
                'countryCode': localeArr[1]
            };
            var divs = document.querySelectorAll('[data-pid^=widget-advanced-content-template-banner-]');
            for (var i = 0; i < divs.length; i++) {
                divs[i].style.height = '0';
            }
            
            if(document.querySelectorAll('[data-pid=widget-advanced-content-template-banner-' + localeArr[0] + ']').length > 0) {
				document.querySelectorAll('[data-pid=widget-advanced-content-template-banner-' + localeArr[0] + ']')[0].style.height = '300px';
			}
            
            model.localeSwitchEndPoint.save(params, {})
                .$promise.then(function (response) {
                    self.selectedLocale = locale;
                    window.sessionStorage.setItem("selected_locale", locale);
                    document.getElementsByTagName('html')[0].setAttribute('lang', localeArr[0]);
                    lpCoreBus.publish(lpCoreI18nUtils.LOCALE_CHANGE_EVENT, locale);
                }, function (err) {
                    lpCoreError.captureException(err);
                });
        };

        var selectedLocale = window.sessionStorage.getItem("selected_locale");
        if (!selectedLocale) {
            selectedLocale = self.selectedLocale;
        }
        self.changeLocale(selectedLocale);
    }

    MainCtrl.prototype.$onInit = function () {
        // Do initialization here
    };

    module.exports = MainCtrl;
});



//////////////////
// WEBPACK FOOTER
// ./scripts/controllers/main-ctrl.js
// module id = 7
// module chunks = 0